export default __webpack_public_path__ + "static/media/arkguide_04.2639ca89.gif";